export class DumbAccountInfo {
    firstName: string;
    lastName: string;
    emailAddress: string;
}